/**
 * Session Counter Replacer View
 */

define(function(require, exports, module) {
    'use strict';
    var BaseReplacerView = require('common/base.replacer.view'),
        user = require('user');

    module.exports = BaseReplacerView.extend({

        tagName: 'span',

        className: 'session-counter',

        accessRules: {
            allow: ['user']
        },

        subscribe: function() {
            this.listenTo(user, 'change:sessionDuration', this.render);
        },

        render: function() {
            this.$el.html(this.translate('playtech.mobile.system.sessionDuration', user.get('sessionDuration') || 0));
            return this;
        }

    }, {
        nameOfReplacers: [
            'SESSION_DURATION_COUNTER'
        ]
    });
});